export default {
      id: "hasReports-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#hasReports-usage",
      toString: function () {
        return this.url;
      }
    }